export default function FoundersSection() {
  return (
    <section id="founders" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nossos <span className="text-red-600">Fundadores</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça as mentes visionárias por trás da IchiBan Marketing Digital, que transformaram uma ideia em uma agência sem fronteiras de sucesso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="relative mb-8">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-red-600 shadow-lg">
                <img
                  src="https://xbqwyqjd.manus.space/assets/IMG_8283-C9p2IVz2.jpeg"
                  alt="Bruno Tominaga - CEO e Fundador da IchiBan Marketing Digital"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                CEO & Fundador
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Bruno Tominaga</h3>
            <p className="text-red-600 font-semibold mb-4">CEO & Fundador</p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Visionário e estrategista digital com mais de 10 anos de experiência em marketing digital. Bruno é fundador e CEO da IchiBan, especialista em Growth Marketing e Inteligência Artificial, tendo liderado campanhas que geraram milhões em receita para empresas de diversos segmentos. Sua paixão por inovação e trabalho remoto o levou a criar a IchiBan, uma agência que quebra paradigmas tradicionais.
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-center space-x-2 text-gray-600">
                <i className="ri-map-pin-line text-red-600"></i>
                <span className="text-sm">São José dos Campos, SP</span>
              </div>
              <div className="flex items-center justify-center space-x-2 text-gray-600">
                <i className="ri-mail-line text-red-600"></i>
                <span className="text-sm">gerencia@ichiban1.com.br</span>
              </div>
            </div>

            <div className="flex justify-center space-x-4">
              <a
                href="https://www.instagram.com/brunotominaga"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-3 rounded-full hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Instagram do Bruno"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/bruno.tominaga"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Facebook do Bruno"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="mailto:gerencia@ichiban1.com.br"
                className="bg-gray-600 text-white p-3 rounded-full hover:bg-gray-700 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Email do Bruno"
              >
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>

          <div className="bg-gray-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="relative mb-8">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-red-600 shadow-lg">
                <img
                  src="https://xbqwyqjd.manus.space/assets/tatiana_founder-ChfCPx8n.jpeg"
                  alt="Tatiana Tominaga - Co-Fundadora da IchiBan Marketing Digital"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                Co-Fundadora
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Tatiana Tominaga</h3>
            <p className="text-red-600 font-semibold mb-4">Co-Fundadora & Diretora de Operações</p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Especialista em operações digitais e gestão de equipes remotas, Tatiana é co-fundadora da IchiBan e possui ampla experiência na estruturação, padronização e otimização de processos operacionais em agências de marketing digital. Atua de forma estratégica na administração do dia a dia da agência, garantindo eficiência na gestão de projetos, organização de fluxos internos, controle de entregas, prazos e performance das equipes.
              <br /><br />
              Natural de Taubaté, atualmente operando de diversas cidades pelo Brasil, Tatiana alia sua sólida expertise em administração operacional a uma visão estratégica de marketing digital, assegurando alinhamento entre planejamento, execução e resultados. Sua atuação é fundamental para escalar operações, integrar tecnologia aos processos internos e sustentar o crescimento da IchiBan com produtividade, qualidade e governança.
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-center space-x-2 text-gray-600">
                <i className="ri-map-pin-line text-red-600"></i>
                <span className="text-sm">Taubaté, SP (Atualmente Nomad pelo Brasil)</span>
              </div>
              <div className="flex items-center justify-center space-x-2 text-gray-600">
                <i className="ri-mail-line text-red-600"></i>
                <span className="text-sm">gerencia@ichiban1.com.br</span>
              </div>
            </div>

            <div className="flex justify-center space-x-4">
              <a
                href="https://www.instagram.com/tatiana.tominaga/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-3 rounded-full hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Instagram da Tatiana"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100008473082363"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Facebook da Tatiana"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="mailto:gerencia@ichiban1.com.br"
                className="bg-gray-600 text-white p-3 rounded-full hover:bg-gray-700 transition-all duration-300 transform hover:scale-110 w-12 h-12 flex items-center justify-center cursor-pointer"
                title="Email da Tatiana"
              >
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
